import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {StatesService} from '../services/statesService/states.service';
import * as StateActions from '../actions/StatesActions';
import {catchError, exhaustMap, map, mergeMap, of} from 'rxjs';



@Injectable()
export class StateEffects {
  update$ = createEffect(() => this.actions$.pipe(
    ofType(StateActions.retrieveStatesAction),
    mergeMap(action =>
      this.stateService.retrieveStates(action.year)
        .pipe(
          map(states => StateActions.statesReceivedAction({ states })),
          catchError((error: any) => of(StateActions.retrieveStatesErrorAction({ error })))
        ))
  ));
  constructor(
    private stateService: StatesService,
    private actions$: Actions
  ) {
  }
}



/*
@Injectable()
export class StateEffects {
  update$: Observable<Action> = this.action$.pipe(
    ofType<RetrieveStatesAction>(StatesActionTypes.RETRIEVE_STATES),
    mergeMap(action =>
      this.stateService.retrieveStates(action.payload)
        .pipe(
          map(states => ({type: StatesActionTypes.STATES_RECEIVED, payload: states})),
        )
    )
  );

  constructor(private stateService: StatesService,
              private action$: Actions, private store: Store<AppState>) {
  }
}
*/
